<template>
  <div class="IncreaseChannel">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="beforeCloseComponents"
      @close="closeComponents"
    >
      <el-form
        class="custom-formItem"
        ref="formData"
        label-width="100px"
        inline
        :model="formData"
        :rules="rulesFormData"
      >
        <el-form-item label="物品类目">
          <el-select
            v-model="formShow.categoryId"
            filterable
            @change="selectChange($event, 'productCategory')"
          >
            <el-option
              v-for="item in listProductCategory"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国家" prop="countryId">
          <el-select v-model="formData.countryId" filterable>
            <el-option
              v-for="item in listCountry"
              :key="item.id"
              :label="item.countryName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- S：占位 勿删 -->
        <el-form-item></el-form-item>
        <!-- E：占位 勿删 -->
        <el-form-item label="中文品名" prop="productName">
          <el-select
            v-model="formData.productName"
            filterable
            value-key="id"
            @change="selectChange($event, 'productName')"
          >
            <el-option
              v-for="item in listProductName"
              :key="item.id"
              :label="item.chineseName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="英文品名">
          <el-input placeholder="请输入" v-model="formShow.englishName" readonly></el-input>
        </el-form-item>
        <el-form-item label="海关编号">
          <el-input placeholder="请输入" v-model="formShow.customsNo" readonly></el-input>
        </el-form-item>
        <el-form-item label="尺寸范围" prop="sizeId">
          <el-select v-model="formData.sizeId" placeholder="请选择">
            <el-option
              v-for="item in listSizeRange"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="重量范围" prop="weightId">
          <el-select v-model="formData.weightId" placeholder="请选择">
            <el-option
              v-for="item in listWeightRange"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物品类型" prop="itemId">
          <el-select v-model="formData.itemId" placeholder="请选择">
            <el-option
              v-for="item in listProductType"
              :key="item.id"
              :label="item.itemTypeName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申报数量" prop="applyCount">
          <el-input placeholder="请输入" v-model="formData.applyCount"></el-input>
        </el-form-item>
        <el-form-item label="申报单价" prop="applyPrice">
          <el-input placeholder="请输入" v-model="formData.applyPrice"></el-input>
        </el-form-item>
        <el-form-item label="申报总值" prop="applyTotal">
          <el-input placeholder="请输入" v-model="formData.applyTotal"></el-input>
        </el-form-item>
        <el-form-item label="申报体积">
          <el-row type="flex" justify="space-between" align="middle">
            <el-form-item prop="applyLength" class="w100">
              <el-input v-model="formData.applyLength"></el-input>
            </el-form-item>
            <div style="padding:0 10px;">X</div>
            <el-form-item prop="applyWidth" class="w100">
              <el-input v-model="formData.applyWidth"></el-input>
            </el-form-item>
            <div style="padding:0 10px;">X</div>
            <el-form-item prop="applyHeight" class="w100">
              <el-input v-model="formData.applyHeight"></el-input>
            </el-form-item>
          </el-row>

          <!-- <el-input placeholder="请输入" v-model="formData.applyVolume"></el-input> -->
        </el-form-item>
        <el-form-item label="申报重量" prop="applyWeight">
          <el-input placeholder="请输入" v-model="formData.applyWeight"></el-input>
        </el-form-item>
        <el-form-item label="物流" style="width: 50%" required>
          <el-row type="flex" align="middle">
            <el-form-item class="w100" prop="channelData" style="margin-right: 10px;">
              <el-select
                v-model="formData.channelData"
                placeholder="请选择"
                value-key="itemTypeId"
                @change="selectChange($event, 'logistics')"
              >
                <el-option
                  v-for="item in listLogistics"
                  :key="item.id"
                  :label="item.itemTypeName"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="w100" prop="channelMethodData">
              <el-select
                v-model="formData.channelMethodData"
                placeholder="请选择"
                value-key="value"
                filterable
              >
                <el-option
                  v-for="item in listLogisticsMethod"
                  :key="item.id"
                  :label="item.title"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </el-form-item>
        <el-form-item label="申报SKU" style="width: 50%" prop="applySku">
          <el-button type="primary" @click="selectRecordSKU">备案SKU</el-button>
          <el-input
            placeholder="请输入"
            v-model="formData.applySku"
            style="width: calc(100% - 90px - 20px);margin-left: 20px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="启用状态" prop="status">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button type="primary" @click="handleIncrease" :loading="loadingIncrease">完 成</el-button>
      </div>

      <el-dialog title="选择备案SKU" append-to-body :visible.sync="dialogVisibleThird">
        <el-table :data="listDialogTable" border style="width: 100%">
          <el-table-column prop="sku" label="SKU" align="center"></el-table-column>
          <el-table-column label="申报品名" align="center">
            <template slot-scope="scope">
              <div>英文：{{ scope.row.englishName }}</div>
              <div>中文：{{ scope.row.chinaName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="图片" width="200" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.productImages">
                <el-popover
                  trigger="hover"
                  placement="right"
                  prop="orderItems.imageUrl"
                  v-if="scope.row.productImages[0]"
                >
                  <el-image style="width: 200px;height: 200px;" :src="scope.row.productImages[0]" />
                  <div slot="reference">
                    <el-image
                      style="width: 100px;height: 100px;"
                      :src="scope.row.productImages[0]"
                    />
                  </div>
                </el-popover>
                <!-- <el-button
                  type="text"
                  size="mini"
                  v-else
                  @click="getOriginalImg(item)"
                  style="padding: 0;"
                >查看原图</el-button>-->
              </div>
            </template>
          </el-table-column>
          <el-table-column label="海关审核状态" align="center" size="mini">
            <template slot-scope="scope">
              <div style="width: 130px;text-align: left;margin: 0 auto;">
                <span>北美：</span>
                <span v-if="scope.row.naStatus === 0">待审核</span>
                <span
                  v-else-if="scope.row.naStatus === 1"
                  :style="{color: scope.row.naStatus === 1 ? 'green' : ''}"
                >审核通过</span>
                <span
                  v-else-if="scope.row.naStatus === 2"
                  :style="{color: scope.row.naStatus === 2 ? 'red' : ''}"
                >审核不予通过</span>
              </div>
              <div style="width: 130px;text-align: left;margin: 0 auto;">
                <span>欧洲：</span>
                <span v-if="scope.row.eurStatus === 0">待审核</span>
                <span
                  v-else-if="scope.row.eurStatus === 1"
                  :style="{color: scope.row.eurStatus === 1 ? 'green' : ''}"
                >审核通过</span>
                <span
                  v-else-if="scope.row.eurStatus === 2"
                  :style="{color: scope.row.eurStatus === 2 ? 'red' : ''}"
                >审核不予通过</span>
              </div>
              <div style="width: 130px;text-align: left;margin: 0 auto;">
                <span>中国：</span>
                <span v-if="scope.row.zhStatus === 0">待审核</span>
                <span
                  v-else-if="scope.row.zhStatus === 1"
                  :style="{color: scope.row.zhStatus === 1 ? 'green' : ''}"
                >审核通过</span>
                <span
                  v-else-if="scope.row.zhStatus === 2"
                  :style="{color: scope.row.zhStatus === 2 ? 'red' : ''}"
                >审核不予通过</span>
              </div>
              <div style="width: 130px;text-align: left;margin: 0 auto;">
                <span>日本：</span>
                <span v-if="scope.row.jpStatus === 0">待审核</span>
                <span
                  v-else-if="scope.row.jpStatus === 1"
                  :style="{color: scope.row.jpStatus === 1 ? 'green' : ''}"
                >审核通过</span>
                <span
                  v-else-if="scope.row.jpStatus === 2"
                  :style="{color: scope.row.jpStatus === 2 ? 'red' : ''}"
                >审核不予通过</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="primary" @click="checkedRecordSKU(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="center" align="middle" style="margin-top: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageDialog"
            :page-sizes="[10, 20, 50]"
            :page-size="sizeDialog"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalDialog"
          ></el-pagination>
        </el-row>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'

export default {
  name: 'IncreaseChannel',
  props: {
    listProductCategory: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    listCountry: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },

    listSizeRange: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    listWeightRange: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    listProductType: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    listLogistics: {
      type: Array,
      required: true,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      dialogTitle: '添加渠道',
      dialogVisible: false,
      formShow: {
        categoryId: '',
        englishName: '',
        customsNo: ''
      },

      formData: {
        countryId: '',
        productName: null,
        // productNameId: '',
        sizeId: '',
        weightId: '',
        itemId: '',
        applyCount: '1',
        applyPrice: '17',
        applyTotal: '17',
        applyWeight: '1',
        applyLength: '1',
        applyWidth: '1',
        applyHeight: '1',
        channelData: null,
        channelMethodData: null,
        // channelType: '',
        // channelName: '',
        // channelWay: '',
        // chineseChannelWay: '',
        applySku: '',
        status: 1,
      },
      rulesFormData: {
        countryId: [
          { required: true, message: '请选择国家', trigger: 'change' }
        ],
        productName: [
          { required: true, message: '请选择中文品名', trigger: 'change' }
        ],
        sizeId: [
          { required: true, message: '请选择尺寸范围', trigger: 'change' }
        ],
        weightId: [
          { required: true, message: '请选择重量范围', trigger: 'change' }
        ],
        itemId: [
          { required: true, message: '请选择物品类型', trigger: 'change' }
        ],
        applyCount: [
          { required: true, message: '请输入申报数量', trigger: 'blur' }
        ],
        applyPrice: [
          { required: true, message: '请输入申报单价', trigger: 'blur' }
        ],
        applyTotal: [
          { required: true, message: '请输入申报总值', trigger: 'blur' }
        ],
        applyWeight: [
          { required: true, message: '请输入申报重量', trigger: 'blur' }
        ],
        applyLength: [
          { required: true, message: '请输入长度', trigger: 'blur' }
        ],
        applyWidth: [
          { required: true, message: '请输入宽度', trigger: 'blur' }
        ],
        applyHeight: [
          { required: true, message: '请输入高度', trigger: 'blur' }
        ],
        channelData: [
          { required: true, message: '物流选择有误', trigger: 'change' }
        ],
        channelMethodData: [
          { required: true, message: '物流选择有误', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择启用状态', trigger: 'change' }
        ]
      },
      loadingIncrease: false,
      listProductName: [],
      listLogisticsMethod: [],

      dialogVisibleThird: false,
      pageDialog: 1,
      sizeDialog: 10,
      listDialogTable: [],
      totalDialog: 0
    }
  },
  methods: {
    async initComponents(item) {
      this.dialogVisible = true
      if (item) {
        this.dialogTitle = '编辑渠道'
        this.formShow = {
          categoryId: item.categoryId,
          englishName: item.englishName,
          customsNo: item.customsNo,
        }
        await this.getListProductName()
        this.formData = {
          id: item.id,
          countryId: item.countryId,
          productName: this.listProductName.find(key => key.id === item.productNameId),
          sizeId: item.sizeId,
          weightId: item.weightId,
          itemId: item.itemId,
          applyCount: item.applyCount,
          applyPrice: item.applyPrice,
          applyTotal: item.applyTotal,
          applyWeight: item.applyWeight,
          applyLength: item.applyLength,
          applyWidth: item.applyWidth,
          applyHeight: item.applyHeight,
          channelData: this.listLogistics.find(key => key.itemTypeId === item.channelType + ''),
          channelMethodData: null,
          applySku: item.applySku,
          status: item.status,
        }
        await this.getListLogisticsMethod()
        this.formData.channelMethodData = this.listLogisticsMethod.find(key => key.value === item.channelWay)
      }
    },
    beforeCloseComponents(done) {
      this.$refs.formData.resetFields()
      // this.$refs.formData.clearValidate()
      done()
    },
    closeComponents() {
      this.dialogTitle = '添加渠道'
      this.loadingIncrease = false
      this.formShow = this.$options.data().formShow
      this.listProductName = []
      this.listLogisticsMethod = []
      this.$emit('close')
    },
    selectChange(event, type) {
      switch (type) {
        case 'productCategory':
          this.formShow.englishName = ''
          this.formShow.customsNo = ''
          this.listProductName = []
          this.getListProductName()
          break
        case 'productName':
          this.formShow.englishName = event.englishName
          this.formShow.customsNo = event.customsNo
          break
        case 'logistics':
          this.listLogisticsMethod = []
          this.getListLogisticsMethod()
          break
        default:
          console.log('这里是default，检查一下type的值！')
          break
      }
    },
    handleIncrease() {
      this.$refs.formData.validate((valid) => {
        if (!valid) return
        let API = Baseurl + 'logisticsConfigurationController/insertLogisticsChannel'

        if (this.dialogTitle === '编辑渠道') {
          API = Baseurl + 'logisticsConfigurationController/updateLogisticsChannel'
        }

        this.formData.productNameId = this.formData.productName.id
        delete this.formData.productName
        this.formData.channelName = this.formData.channelData.itemTypeName
        this.formData.channelType = this.formData.channelData.itemTypeId
        delete this.formData.channelData
        this.formData.channelWay = this.formData.channelMethodData.value
        this.formData.chineseChannelWay = this.formData.channelMethodData.title
        delete this.formData.channelMethodData

        const paramsData = this.formData
        this.loadingIncrease = true

        ajaxPost(API, paramsData).then(res => {
          const { code } = res.data
          this.loadingIncrease = false
          if (code === 200) {
            this.$refs.formData.resetFields()
            this.dialogVisible = false
            this.$message.success('操作成功！')
          }
        })
      })
    },
    getListProductName() {
      const API = Baseurl + 'logisticsConfigurationController/getLogisticsProductNamesByCategoryId'
      const paramsData = { categoryId: this.formShow.categoryId }
      return new Promise((resolve, reject) => {
        ajaxPost(API, paramsData).then(res => {
          const { code, data } = res.data
          if (code === 200) {
            this.listProductName = data
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    getListLogisticsMethod() {
      const { itemTypeId: type } = this.formData.channelData;
      const API = Baseurl + 'logisticsController/getShippingMethodList'
      const paramsData = { type };
      return new Promise((resolve, reject) => {
        ajaxPost(API, paramsData).then(res => {
          const { code, data } = res.data
          if (code === 200) {
            let itemTitleKey = "";
            let itemValueKey = "";
            if (type === "1") {
              itemTitleKey = "cnName";
              itemValueKey = "methodCode";
            } else if (type === "2") {
              itemTitleKey = "cname";
              itemValueKey = "code";
            } else if (type === "3") {
              itemTitleKey = "name";
              itemValueKey = "name";
            } else if (type === "5") {
              itemTitleKey = "cnName";
              itemValueKey = "code";
            }
            if (!itemTitleKey) return;
            this.logisticsTwoList = [];
            data.forEach(item => {
              const itemObj = {
                id: item.id || item.ytId,
                title: item[itemTitleKey],
                value: item[itemValueKey],
              };
              this.listLogisticsMethod.push(itemObj);
            });
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.sizeDialog = val;
      this.selectRecordSKU();
    },
    handleCurrentChange(val) {
      this.pageDialog = val;
      this.selectRecordSKU();
    },
    selectRecordSKU() {
      const API = Baseurl + 'recordSkuController/selectRecordSkuList'
      const paramsData = {
        page: this.pageDialog,
        size: this.sizeDialog,
        searchString: ''
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.dialogVisibleThird = true
          this.listDialogTable = data.list
          this.totalDialog = data.total
        }
      })
    },
    checkedRecordSKU(row) {
      this.formData.applySku = row.sku
      this.dialogVisibleThird = false
    },
  }
}
</script>

